import { extraDarkTurquoise, iconClose, playGrey15, regularWhite } from 'app/ui-components/design-tokens';
import PlayButton from 'app/ui-components/PlayButton/PlayButton';
import { playFontIcon, playFontSize } from 'app/ui-components/typography/helpers';
import PlayText from 'app/ui-components/typography/PlayText/PlayText';
import styled, { css } from 'styled-components';
import { playFocus } from '../../ui-components/utils.styles';
import { device } from '../breakpoints';

const surveyImage =
    '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';

const thankYouImage =
    'PHN2ZyB3aWR0aD0iNTgiIGhlaWdodD0iNTEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxwYXRoIGQ9Ik0xMS4wMDYgMTkuOTVjLS4zMjYgMC0uNjUxLS4xMy0uODk5LS4zODdsLTcuMjkzLTcuNjFjLS45OTUtMS4wNC0xLjUwMy0yLjQ4NC0xLjQzMy00LjA2Ni4wNzEtMS41ODMuNzIzLTMuMDU1IDEuNzQzLTMuOTM5IDEuODItMS41NzQgNC42MDMtMS4zOTEgNi4zMzEuNDE2Ljc3LjgwNCAxLjI3IDEuNTQzIDEuNTg0IDIuMTA2LjMtLjU1MS43NTgtMS4yOCAxLjQyLTIuMDc1IDEuNTE2LTEuODI1IDQuNTcyLTIuMDQyIDYuNDEyLS40NTggMS4wMjIuODgzIDEuNjc1IDIuMzU1IDEuNzQ3IDMuOTM3LjA3MyAxLjU4Mi0uNDM0IDMuMDI3LTEuNDI3IDQuMDY4bC03LjI4NiA3LjYxOGMtLjI0OC4yNi0uNTczLjM5LS45LjM5eiIgaWQ9ImEiLz48L2RlZnM+PGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj48cGF0aCBkPSJNNTEuNDUgNi41NjhMMTIuNzg3IDEuNzc1YTYgNiAwIDAwLTYuNjk1IDUuMjNMMy4xMSAzMS41MzVhNiA2IDAgMDA1LjIxOSA2LjY3OWwxMy43MjUgMS43YTIgMiAwIDAxMS40OTUgMWwyLjY4IDQuNzRhMSAxIDAgMDAxLjU5LjJsMy44OTMtNC4wNDZhMiAyIDAgMDExLjY5OS0uNTk3bDEzLjU0OCAxLjc1OWE2IDYgMCAwMDYuNzI5LTUuMjI2bDIuOTc5LTI0LjQ5N2E2IDYgMCAwMC01LjIxOC02LjY3OXoiIGZpbGw9IiM2NDFFNzgiLz48dXNlIGZpbGw9IiNGRkYiIHhsaW5rOmhyZWY9IiNhIiB0cmFuc2Zvcm09InJvdGF0ZSg3IC03Ny4zMSAxNzIuMDE1KSIvPjwvZz48L3N2Zz4=';
export const Heading = styled.span`
    font-weight: bold;
    ${playFontSize(1.7)};

    @media ${device.GteSmall} {
        ${playFontSize(2)};
    }

    @media ${device.FullScreen} {
        ${playFontSize(2.4)};
    }
`;

export const ThankYouHeading = styled.span`
    font-weight: bold;
    ${playFontSize(1.7)};

    @media ${device.GteSmall} {
        ${playFontSize(1.8)};
    }
`;

const borderRadius = '8px';
const SurveyContainer = css`
    background: ${extraDarkTurquoise};
    color: ${regularWhite};
    border-radius: ${borderRadius};
    display: flex;
    position: relative;
`;

export const StyledSurvey = styled.div`
    ${SurveyContainer}
`;

export const StyledThankYou = styled.div`
    padding-top: 9px;
    position: relative;
`;

export const StyledSurveyTextContainer = styled.div`
    padding: 20px 0 20px 15px;
    flex: 1 1 auto;

    @media ${device.GteSmall} {
        padding: 20px 15px 20px 20px;
    }
`;

export const ThankYouTextContainer = styled.div`
    padding: 15px 0 15px 15px;
    flex: 1 1 auto;

    @media ${device.GteSmall} {
        padding: 20px 0 20px 20px;
    }

    @media ${device.FullScreen} {
        padding: 20px 0 20px 25px;
    }
`;

export const StyledSurveyImage = styled.div`
    background-image: url('data:image/svg+xml;base64,${surveyImage}');
    width: 105px;
    background-position: 0 -37px;
    margin-left: 10px;
    background-repeat: no-repeat;
    background-size: 161px auto;
    flex: 0 0 auto;
    position: relative;
    border-radius: ${borderRadius};
`;

export const StyledThankYouImage = styled.div`
    background-image: url('data:image/svg+xml;base64,${thankYouImage}');
    width: 45px;
    height: 38px;
    background-size: cover;
    background-repeat: no-repeat;
    position: absolute;
    right: 50px;
    top: 0;
    z-index: 1;

    @media ${device.GteSmall} {
        width: 48px;
        height: 40px;
    }
`;

export const CloseButton = styled.button`
    ${playFocus()}
    cursor: pointer;
    font-size: 11px;
    position: absolute;
    padding: 3px;
    color: ${regularWhite};
    right: 10px;
    top: 10px;
    background: ${playGrey15};
    border: none;
    border-radius: 50%;

    &:after {
        ${playFontIcon(1.6)}
        content: '${iconClose}';
    }
`;

export const Button = styled(PlayButton)`
    margin-top: 10px;
    display: inline-flex;
    align-items: center;
`;

export const Text = styled(PlayText)`
    margin-top: 4px;
`;

export const FixedContainer = styled.div`
    margin: 0 10px 10px 10px;

    @media ${device.GteSmall} {
        margin: 0;
        display: block;
        position: fixed;
        z-index: 10000;

        min-width: 420px;
        will-change: transform;
        right: 10px;
        bottom: 10px;
    }

    @media ${device.GteXLarge} {
        right: 20px;
        bottom: 20px;
    }

    @media ${device.FullScreen} {
        min-width: 450px;
        right: 40px;
        bottom: 40px;
    }
`;
